import { useState, useEffect } from 'react'
import { Box, Button, Checkbox, Grid2, Typography } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { useAllUserList, useTranerUnderCoorList } from '../../assets/api/useAdminApi'
import useAuthStore from '../../store/useAuthStore'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Grid_Gap } from '../../shared/constants'
import { useDialog } from '../../shared/hook/useDialog'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import SelectBoxField from '../../shared/components/formfields/SelectBoxField'
import { TextSkeleton } from '../../shared/utils/SkeletonCom'
import AssignClustertoCoordinator from '../commonfile/AssignClustertoCoordinator'
import CoordinatorListTable from '../commonfile/CoordinatorListTable'
import api from '../../assets/nodeApi/axiosInstance'
import AssignZoneToMarketingExecutive from './AssignZoneToMarketingExecutive'

const CoOrdinatorList = () => {
  const queryClient = useQueryClient()
  const { open: openAparmentRemove, handleClickOpen: handleClickOpenApartmentRemove, handleClose: handleCloseApartmentRemove } = useDialog();
  const [coordinatorId, setCoordinatorId] = useState("")
  const { data: apartmentList, isLoading: isApartmentLoading } = useTranerUnderCoorList(coordinatorId)
  const { data: allUserList, isLoading: isUserloading } = useAllUserList({ role: "coordinator" })
  const initialOptions =
    apartmentList?.apartments?.map((item) => ({
      check: true,
      id: item?.id,
      value: item?.apartment_name,
      label: item?.apartment_name,
    })) || [];

  const [options, setOptions] = useState(initialOptions);

  useEffect(() => {
    setOptions(initialOptions);
  }, [apartmentList]);

  const handleActionChange = (index, isChecked) => {
    setOptions((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, check: isChecked } : item
      )
    );
  };

  const CoordinatorOption = allUserList?.data?.map((item, index) => ({
    id: item?.id || index + 1,
    value: item?.firstname,
    label: item?.firstname
  })) || [];

  const handleChangeCoordinator = (id) => {
    setCoordinatorId(id)
  };
  const { showToaster } = useToaster();
  const { token } = useAuthStore();
  const mutationremove = useMutation({
    mutationFn: (formData) => api.post("modify-assigned-apartments", formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
  });

  const handleRemoveApartment = () => {
    const obj = {
      user_id: coordinatorId,
      apartments_to_remove: options
        .filter(item => !item.check)
        .map(item => item.id)
    }

    mutationremove.mutate(obj, {
      onSuccess: (response) => {
        queryClient.invalidateQueries({ queryKey: ['coordinator-apartment-count', coordinatorId] })
        showToaster('Success', response?.data?.message, 'success')
      },
      onError: () => {
        showToaster("Something Went wrong", 'Error', 'error')
      }
    });

    setCoordinatorId("")
    handleCloseApartmentRemove()

  }
  return (
    <Box>
      <CustomDivider />
      <NormalContainerWithHeader>
        <Grid2 container display={"flex"} justifyContent={"end"} spacing={Grid_Gap}>
          <Grid2 children size={{ xs: 12, sm: 4, md: 2.5 }}>
            <Button variant='outlined' fullWidth onClick={handleClickOpenApartmentRemove}>Remove Apartment</Button>
          </Grid2>
        </Grid2>
      </NormalContainerWithHeader>
      <CustomDivider orientation='horizontal' />
      <AssignZoneToMarketingExecutive role={"Zonal Coordinator"} />
      <CustomDivider orientation='horizontal' />
      <NormalContainerWithHeader headerText={"Assign Cluster to Coordinator"}>
        <AssignClustertoCoordinator />
      </NormalContainerWithHeader>
      <CustomDivider orientation='horizontal' />
      <CoordinatorListTable />
      <MainDialogBox open={openAparmentRemove} handleClose={() => { handleCloseApartmentRemove(); setCoordinatorId("") }} width={"40%"}>
        <SelectBoxField
          label="Select Coordinator"
          options={CoordinatorOption}
          isRequired={true}
          onChange={handleChangeCoordinator}
          isloading={isUserloading}
        />
        <CustomDivider />
        <Box>
          {
            (isApartmentLoading && coordinatorId) && <TextSkeleton line={5} />
          }
          {!isApartmentLoading &&
            options.map((item, index) => (
              <Box key={item.id} display="flex" alignItems="center">
                <Checkbox
                  checked={item.check}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => handleActionChange(index, e.target.checked)}
                  sx={{
                    color: 'error.main',
                    '&.Mui-checked': { color: 'error.main' },
                    mr: 1,
                  }}
                />
                <Typography>{item?.label}</Typography>
              </Box>
            ))
          }
          <CustomDivider />
          <Button variant='contained' fullWidth onClick={handleRemoveApartment} disabled={options.length === 0}>Remove</Button>
        </Box>
      </MainDialogBox>
    </Box>
  )
}

export default CoOrdinatorList